import { render } from "./MenusWrap.vue?vue&type=template&id=181d599b&scoped=true"
import script from "./MenusWrap.vue?vue&type=script&lang=js"
export * from "./MenusWrap.vue?vue&type=script&lang=js"

import "./MenusWrap.vue?vue&type=style&index=0&id=181d599b&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-181d599b"]])

export default __exports__